const CircleAlertIcon = ({ className, fill }) => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" width="44" height="44" rx="22" fill="#FFEEEC" />
      <path
        d="M21.3239 26.6665C21.3239 26.0222 21.8462 25.4998 22.4906 25.4998H22.501C23.1454 25.4998 23.6677 26.0222 23.6677 26.6665C23.6677 27.3108 23.1454 27.8332 22.501 27.8332H22.4906C21.8462 27.8332 21.3239 27.3108 21.3239 26.6665Z"
        fill={fill || "#FF0000"}
      />
      <path
        d="M21.6247 23.1665C21.6247 23.6498 22.0164 24.0415 22.4997 24.0415C22.9829 24.0415 23.3747 23.6498 23.3747 23.1665V18.4998C23.3747 18.0166 22.9829 17.6248 22.4997 17.6248C22.0164 17.6248 21.6247 18.0166 21.6247 18.4998V23.1665Z"
        fill={fill || "#FF0000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5887 10.3507C21.8305 9.93845 23.1688 9.93845 24.4107 10.3507C25.6474 10.7612 26.6185 11.7348 27.594 13.1028C28.5663 14.4662 29.6406 16.3672 31.0255 18.8177L31.0798 18.914C32.4649 21.3648 33.5392 23.2658 34.2088 24.8074C34.8815 26.3565 35.2166 27.694 34.9492 28.979C34.6801 30.2727 34.0163 31.4492 33.0496 32.3385C32.0853 33.2255 30.7722 33.5997 29.1189 33.7795C27.4749 33.9582 25.3244 33.9582 22.5566 33.9582H22.4428C19.675 33.9582 17.5245 33.9582 15.8805 33.7795C14.2272 33.5997 12.9141 33.2255 11.9498 32.3385C10.9831 31.4492 10.3193 30.2727 10.0501 28.979C9.78277 27.694 10.1178 26.3565 10.7906 24.8074C11.4601 23.2658 12.5344 21.3648 13.9195 18.9139L13.9739 18.8178C15.3588 16.3672 16.4331 14.4662 17.4054 13.1028C18.3809 11.7348 19.3519 10.7612 20.5887 10.3507ZM23.8594 12.0116C22.9755 11.7182 22.0239 11.7182 21.14 12.0116C20.4447 12.2424 19.7457 12.8351 18.8302 14.1188C17.9179 15.3982 16.888 17.2182 15.4701 19.7271C14.0523 22.2358 13.0243 24.0572 12.3958 25.5045C11.7661 26.9543 11.6084 27.8774 11.7634 28.6225C11.959 29.5623 12.4401 30.4118 13.1345 31.0505C13.6799 31.5521 14.5296 31.8723 16.0696 32.0397C17.6078 32.2069 19.663 32.2082 22.4997 32.2082C25.3363 32.2082 27.3916 32.2069 28.9297 32.0397C30.4697 31.8723 31.3195 31.5521 31.8648 31.0505C32.5592 30.4118 33.0404 29.5623 33.2359 28.6225C33.3909 27.8774 33.2332 26.9543 32.6036 25.5045C31.9751 24.0572 30.947 22.2358 29.5292 19.7271C28.1114 17.2182 27.0815 15.3982 26.1692 14.1188C25.2537 12.8351 24.5547 12.2424 23.8594 12.0116Z"
        fill={fill || "#FF0000"}
      />
    </svg>
  );
};

export default CircleAlertIcon;
